<template>
  <v-container>
    <CRUDCriteria :showReset='false' :showSearch='false' :showAdditionalActions='false'>
      <template v-slot:criteriaRows>
        <div class='mt-0 ml-6 mr-6 pa-6'>
          <v-row class='ma-n4' align="center">
            <v-col cols='3' class='pt-0 pb-0'>
              <CommonDropDowns :isItTaxYear=true :taxYearItems="taxYearOptions"
              @change="dataFromCommonDropDowns"
              :criteriaState="criteriaState"/>
            </v-col>
            <v-col cols='3' class='pt-0 pb-0 '>
              <MultiItemSelect
                label="Tax District"
                item-text="taxDistrictCodeAndName"
                item-value="districtCode"
                :item-list="taxDistrictList"
                :items="taxDistricts"
                @selected-items="selectedTaxDistricts"
              />
            </v-col>
            <v-col cols='auto' class='pt-2'>
              <v-btn color='primary' dense small @click="openTifReportDialog(false)">
                TIF Report
              </v-btn>
            </v-col>
            <v-col cols='auto' class='pt-2'>
              <v-btn color='primary' dense small @click="openTifReportDialog(true)">
                TIFs by City
              </v-btn>
            </v-col>
            <v-col cols='auto' class='pt-2'>
              <v-btn
                color='primary'
                dense
                small
                @click="openDailogforTrailRecords"
              >
                TIF Summary
              </v-btn>
            </v-col>
            <v-col cols='auto' class='pt-2'>
              <v-btn color='primary' dense small @click="reTotal">
                Re-Total
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </template>
      <template v-slot:additionalActions>
        <v-col cols='2' class='pt-2'>
        </v-col>
      </template>
    </CRUDCriteria>
  <v-dialog max-width="400" v-model="dialogforTrailRecords">
    <v-card>
      <v-card-title class="input-text-size">
        Select tax Year
      </v-card-title>
      <v-col>
      <MultiItemSelect id="tmc-payment-report-by-transaction"
        label="By Tax year"
        item-text="name"
        item-value="value"
        :item-list="taxYearSelectItems"
        :items="this.taxYears"
        @selected-items="selectedTaxYearList"
      />
      <v-btn
        color="blue darken-1"
        text
        @click="handleReport"
      >
        OK
      </v-btn>
      <v-btn
        color="blue darken-1"
        text
        @click="closeDialog"
      >
        Cancel
      </v-btn>
      </v-col>
      </v-card>
  </v-dialog>

  <!-- TIF Report Dialog -->
  <v-dialog max-width="600" v-model="tifReportDialog" persistent>
    <v-card>
      <v-card-title class="headline">
        {{ tifReportByCity ? 'Print TIF Districts by City' : 'Print TIF Report' }}
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="6">
              <v-select
                class="input-text-size"
                :items="taxYearList"
                item-text="name"
                item-value="value"
                label="From Tax Year"
                v-model="tifReportCriteria.fromTaxYear"
                dense
              ></v-select>
            </v-col>
            <v-col cols="6">
              <v-select
                class="input-text-size"
                :items="taxYearList"
                item-text="name"
                item-value="value"
                label="To Tax Year"
                v-model="tifReportCriteria.toTaxYear"
                dense
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <ClarionDateControl
                label="From Date"
                v-model="tifReportCriteria.fromDate"
                :isToggle="false"
                classes="input-text-size"
              />
            </v-col>
            <v-col cols="6">
              <ClarionDateControl
                label="To Date"
                v-model="tifReportCriteria.toDate"
                :isToggle="false"
                classes="input-text-size"
              />
            </v-col>
          </v-row>
          <v-row >
            <v-col cols="12">
              <v-select
                class="input-text-size"
                :items="taxDistrictList"
                item-text="taxDistrictCodeAndName"
                item-value="districtCode"
                label="Tax District Dropdown List"
                v-model="tifReportCriteria.taxDistricts"
                dense
                multiple
                chips
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index === 0" small>
                    <span>{{ item.taxDistrictCodeAndName }}</span>
                  </v-chip>
                  <span
                    v-if="index === 1"
                    class="grey--text text-caption"
                  >
                    (+{{ tifReportCriteria.taxDistricts.length - 1 }} others)
                  </span>
                </template>
                <template v-slot:prepend-item>
                  <v-list-item
                    ripple
                    @click="toggleAllTaxDistricts"
                  >
                    <v-list-item-action>
                      <v-icon
                      :color="tifReportCriteria.taxDistricts.length > 0 ? 'indigo darken-4' : ''"
                      >
                        {{ taxDistrictIcon }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        Select All
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
              </v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-checkbox
                class="input-text-size mt-0 pt-0"
                v-model="tifReportCriteria.printDetail"
                label="Print Detail"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="grey darken-1"
          text
          @click="closeTifReportDialog"
        >
          CANCEL
        </v-btn>
        <v-btn
          color="primary"
          text
          @click="handleTifReport"
        >
          PRINT
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </v-container>
</template>
<script>
import {
  mapMutations,
  mapGetters,
  mapActions,
  mapState,
} from 'vuex';
import {
  mdiCloseBox,
  mdiCheckboxBlankOutline,
  mdiMinusBox,
} from '@mdi/js';
import CRUDCriteria from '../../common/base/crud-2.0/CRUDCriteria.vue';
import CommonDropDowns from '../common-utils/CommonDropDowns.mixin.vue';
import ClarionDateControl from '../../common/ClarionDateControl.vue';
import '../../../assets/style.css';
import { clients } from '../../../util/clients';
import MultiItemSelect from '../../common/base/MultiItemSelect.vue';

const { backendRest } = clients.direct;
const taxDistrictBaseCrudKey = 'sharedTaxDistrict';

export default {
  name: 'TifDistrictsCriteria',
  data() {
    return {
      dialogforTrailRecords: false,
      taxYears: [],
      rollTaxYears: [],
      alltaxYears: false,
      tifReportDialog: false,
      tifReportByCity: false,
      tifReportCriteria: {
        fromTaxYear: null,
        toTaxYear: null,
        fromDate: null,
        toDate: null,
        taxDistricts: [],
        printDetail: false,
      },
    };
  },
  props: {
    baseCrudKey: {
      type: String,
      default: '',
    },
  },
  components: {
    CRUDCriteria,
    CommonDropDowns,
    ClarionDateControl,
    MultiItemSelect,
  },
  created() {
    this.loadTaxYear();
    this.loadTifDistrictTaxYears();
    this.initializeTaxDistrictSelection();
    this.loadTaxDistricts();
  },
  computed: {
    ...mapGetters('base/crud', ['criteria', 'items', 'item']),
    ...mapState({
      tifTaxYears: (state) => state.tax.tifDistricts.tifTaxYears,
    }),
    // The tax roll's years plus every year that has a TIF record: next year's TIFs are set up (or
    // copied) before that year's roll is converted, and could not be opened otherwise. Newest first.
    taxYearList() {
      const years = new Set([...this.rollTaxYears, ...this.tifTaxYears]);
      return [...years].sort((a, b) => b - a);
    },
    // MultiItemSelect reads item[itemValue] for Select All, so it needs { name, value } items
    taxYearSelectItems() {
      return this.taxYearList.map((year) => ({ name: year, value: year }));
    },
    // the main Tax Year dropdown (an 'all years' entry, then the years)
    taxYearOptions() {
      return [{ name: 'all years', value: 0 }, ...this.taxYearSelectItems];
    },
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    taxDistrictList() {
      const items = this.items(taxDistrictBaseCrudKey);
      return items
        .filter((i) => i.isTifBase)
        .map((i) => ({
          ...i,
          taxDistrictCodeAndName: `${i.districtCode} ${i.districtName || ''}`,
        }));
    },
    taxDistrictIcon() {
      const tdLen = this.tifReportCriteria.taxDistricts.length;
      const allSelected = tdLen === this.taxDistrictList.length;
      const someSelected = tdLen > 0 && !allSelected;
      if (allSelected) return mdiCloseBox;
      if (someSelected) return mdiMinusBox;
      return mdiCheckboxBlankOutline;
    },

  },

  watch: {
    // keep "every year selected" in the TIF Summary dialog selected as years appear
    taxYearList(newList, oldList) {
      if (this.taxYears.length === oldList.length) this.taxYears = newList;
    },
  },

  methods: {
    ...mapMutations('base/crud', [
      'setCriteria',
    ]),
    ...mapActions('tax/tifDistricts', [
      'reTotalTifRecord',
      'loadTifDistrictTaxYears',
    ]),
    ...mapActions(['reAuth', 'flashWarn']),
    ...mapActions('shared/taxDistrict', [
      'loadTaxDistrict',
    ]),
    ...mapActions('tax/taxCommon', [
      'loadTaxYearList',
    ]),
    async handleReport() {
      // if (!this.fromDate || !this.toDate) {
      //   this.flashWarn('Please select from date and to date !');
      //   return;
      // }
      const { jwt } = await this.reAuth();
      const toUrl = `${backendRest.defaults.baseURL}/taxInquiry/tifDistrict/tif-district-summary?taxYears=${this.taxYears}&token=${jwt}`;
      window.open(toUrl);
    },
    openDailogforTrailRecords() {
      if (this.taxYearList.length > 0) {
        this.dialogforTrailRecords = true;
      } else {
        alert('YPlease select tax year.');
      }
    },
    closeDialog() {
      this.dialogforTrailRecords = false;
    },
    searchByCriteria() {
      this.criteriaState = { ...this.criteriaState };
      this.$emit('loadCRUDList');
    },
    async loadTaxYear() {
      const criteria = {};
      // dontCommit: false leaves the shared list the other tabs read as the tax roll's years only
      this.loadTaxYearList({
        criteria,
        baseCrudKey: taxDistrictBaseCrudKey,
        dontCommit: false,
      }).then((val) => {
        this.rollTaxYears = Array.isArray(val) ? val.filter((year) => year > 0) : [];
      });
    },
    loadTaxDistricts() {
      const criteria = {};
      this.loadTaxDistrict({ criteria, baseCrudKey: taxDistrictBaseCrudKey }).then(() => {
        // Pre-select all TIF base tax districts
        this.tifReportCriteria.taxDistricts = this.taxDistrictList.map((d) => d.districtCode);
      });
    },
    emitSelectedItem(id) {
      this.selectedItems = id;
    },
    initializeTaxDistrictSelection() {
      const { tifTaxDistrict } = this.criteriaState;
      if (Array.isArray(tifTaxDistrict)) {
        this.taxDistricts = tifTaxDistrict;
      } else if (typeof tifTaxDistrict === 'string' && tifTaxDistrict) {
        const selections = tifTaxDistrict.split(',').map((i) => i.trim()).filter(Boolean);
        this.taxDistricts = selections;
        this.criteriaState = { ...this.criteriaState, tifTaxDistrict: selections };
      } else {
        this.taxDistricts = [];
        this.criteriaState = { ...this.criteriaState, tifTaxDistrict: [] };
      }
    },
    dataFromCommonDropDowns(val, whichField) {
      this.criteriaState[whichField] = val;
      this.searchByCriteria();
    },
    selectedTaxYearList(val) {
      this.taxYears = val;
      const val2 = (val || []).length === this.taxYearList.length;
      this.alltaxYears = val2;
    },
    selectedTaxDistricts(val) {
      this.taxDistricts = val;
      this.criteriaState = {
        ...this.criteriaState,
        tifTaxDistrict: val || [],
      };
      this.alltaxDistricts = (val || []).length === this.taxDistrictList.length;
      this.searchByCriteria();
    },
    reTotal() {
      const { baseCrudKey } = this;
      const {
        tifTaxDistrict, distributionTaxDistrict, taxYear, _id,
      } = this.item(this.baseCrudKey);
      let tifTaxDistrictArray = [];
      if (Array.isArray(tifTaxDistrict)) {
        tifTaxDistrictArray = tifTaxDistrict;
      } else if (tifTaxDistrict) {
        tifTaxDistrictArray = [tifTaxDistrict];
      }
      const criteria = {
        tifTaxDistrict: tifTaxDistrictArray,
        distributionTaxDistrict,
        taxYear,
        _id,
      };
      this.reTotalTifRecord({ baseCrudKey, criteria }).then(() => {
        this.searchByCriteria();
      });
    },
    openTifReportDialog(byCity = false) {
      this.tifReportByCity = byCity;
      // Initialize with current tax year if available
      if (this.taxYearList.length > 0) {
        const currentYear = this.criteriaState.taxYear || this.taxYearList[0];
        this.tifReportCriteria.fromTaxYear = currentYear;
        this.tifReportCriteria.toTaxYear = currentYear;
      }
      // Ensure tax districts are pre-selected
      if (this.tifReportCriteria.taxDistricts.length === 0) {
        this.tifReportCriteria.taxDistricts = this.taxDistrictList.map((d) => d.districtCode);
      }
      this.tifReportDialog = true;
    },
    closeTifReportDialog() {
      this.tifReportDialog = false;
    },
    toggleAllTaxDistricts() {
      this.$nextTick(() => {
        if (this.tifReportCriteria.taxDistricts.length === this.taxDistrictList.length) {
          this.tifReportCriteria.taxDistricts = [];
        } else {
          this.tifReportCriteria.taxDistricts = this.taxDistrictList.map((d) => d.districtCode);
        }
      });
    },
    async handleTifReport() {
      // Validate required fields
      if (!this.tifReportCriteria.fromTaxYear || !this.tifReportCriteria.toTaxYear) {
        this.flashWarn('Please select From and To Tax Year!');
        return;
      }
      if (!this.tifReportCriteria.fromDate || !this.tifReportCriteria.toDate) {
        this.flashWarn('Please select From and To Date!');
        return;
      }
      if (
        !this.tifReportCriteria.taxDistricts || this.tifReportCriteria.taxDistricts.length === 0) {
        this.flashWarn('Please select at least one Tax District!');
        return;
      }

      const { jwt } = await this.reAuth();
      const params = [
        `token=${jwt}`,
        `fromTaxYear=${this.tifReportCriteria.fromTaxYear}`,
        `toTaxYear=${this.tifReportCriteria.toTaxYear}`,
        `fromDate=${this.tifReportCriteria.fromDate}`,
        `toDate=${this.tifReportCriteria.toDate}`,
        `taxDistricts=${encodeURIComponent(JSON.stringify(this.tifReportCriteria.taxDistricts))}`,
        `printDetail=${this.tifReportCriteria.printDetail}`,
      ];
      const queryString = `?${params.join('&')}`;
      const reportRoute = this.tifReportByCity ? 'tif-report-by-city' : 'tif-report';
      const toUrl = `${backendRest.defaults.baseURL}/taxInquiry/tifDistrict/${reportRoute}${queryString}`;
      window.open(toUrl, '_blank');
      this.closeTifReportDialog();
    },

  },
};
</script>

<style scoped>
.label {
  font-size: 0.85rem;
}
</style>
